import React from 'react';

import { Loader } from 'components/Loader';
import { useTheme } from '@emotion/react';
import { BackButtonContainer } from './BackButton.style';
import { ReactComponent as Arrow } from './arrow.svg';

export type BackButtonProps = {
    isLoading?: boolean;
    isPrimary?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const BackButton: React.FunctionComponent<BackButtonProps> = ({
    isLoading = false,
    isPrimary = false,
    onClick,
    ...otherProps
}) => {
    const theme = useTheme();
    return (
        <BackButtonContainer
            type="button"
            data-testid="back-button"
            onClick={onClick}
            isPrimary={isPrimary}
            {...otherProps}
        >
            {isLoading ? (
                <Loader />
            ) : (
                <Arrow
                    color={
                        isPrimary
                            ? theme.feature.buttonMain.fontColor
                            : theme.feature.buttonSecondary.fontColor
                    }
                />
            )}
        </BackButtonContainer>
    );
};
